import type { XEventListener } from '@nab/x-types';
import { PlatformAgnosticEventBus } from './PlatformAgnosticEventBus';

export abstract class AbstractEventBus extends PlatformAgnosticEventBus {
    protected handleLegacyPublish<TDATA = any>(eventName: string, data: TDATA): void {
        if (eventName.match(/^nabx:/)) {
            window.dispatchEvent(
                new CustomEvent(eventName, {
                    bubbles: true,
                    composed: true,
                    detail: data
                })
            );
        }
    }

    protected handleLegacySubscribe<T = any, R = void>(eventName: string, listener: XEventListener<T, R>): EventListener {
        let windowListener;
        if (eventName.match(/^nabx:/)) {
            windowListener = (event: CustomEvent) => {
                listener(event.detail);
            };
            window.addEventListener(eventName, windowListener);
        }
        return windowListener;
    }

    protected handleLegacyUnsubscribe(eventName: string, legacyListener: EventListener): void {
        // Remove window listener if one is registered
        window.removeEventListener(eventName, legacyListener);
    }
}
